import { Navigate, Outlet } from "react-router-dom";
import { useAuthProvider } from "./provider";
import { RoutePath } from "../../route/route-path";

export function RequireAuth() {
    const auth = useAuthProvider();

    if (!auth.isReady) return null;
    if (!auth.isAuthenticated) {
        return <Navigate to={RoutePath.login} replace />;
    }
    return <Outlet />;
}

export function GuestOnly() {
    const auth = useAuthProvider();

    if (!auth.isReady) return null;
    if (auth.isAuthenticated) {
        return <Navigate to={RoutePath.initial} replace />;
    }
    return <Outlet />;
}
